import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Link } from 'react-router-dom'

const JoinCommunity = () => {
    return (
        <>
            <Header />
            <div className='relative container w-full mx-auto md:px-40 px-6 md:py-3 py-3'>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-6 text-center mt-6">

                    <Link to='/freelancer-form' className="border-2 border-logo rounded-lg shadow-xl p-3 md:p-6 py-6 text-cente transition-all duration-500 ease-in-out transform">
                        <div>
                            <h3 className="md:text-2xl text-xl font-bold text-center">Join as a Freelancer</h3>
                            <div className="border-t-4 border-orange-500 mt-1 mx-auto w-10 rounded-full"></div>
                        </div>
                        <p className='md:w-[90%] mx-auto my-3'>Join AS-Tech as a freelancer, showcase your skills globally, set your rates, and work on exciting, impactful projects today</p>
                        <Link
                            to='/freelancer-form'
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-4"
                        >
                            Join Now
                        </Link>
                    </Link>


                    <Link to='/client-login' className="border-2 border-logo rounded-lg shadow-xl p-3 md:p-6 py-6 text-cente transition-all duration-500 ease-in-out transform ">
                        <div>
                            <h3 className="md:text-2xl text-xl font-bold text-center">Join as a Client</h3>
                            <div className="border-t-4 border-orange-500 mt-1 mx-auto w-10 rounded-full"></div>
                        </div>
                        <p className='md:w-[90%] mx-auto my-3'>Join AS-Tech as a client to get your projects done with ease. Experts will handle your work. The ongoing project in AS-Project Portal will be easy to detect progress.</p>
                       
                        <Link
                            to='/client-login'
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-4"
                        >
                            Join Now
                        </Link>
                    </Link>

                </div>
            </div>
            <div className='relative container md:w-[63%] mx-auto md:px-40 px-6 md:py-3 py-3'>
                <div className="flex justify-center items-center text-center mb-24">
                    <Link to='/mentor-login' className="w-full border-2 border-logo rounded-lg shadow-xl p-3 py-6 md:p-6 text-cente transition-all duration-500 ease-in-out transform ">
                        <div>
                            <h3 className="md:text-2xl text-xl font-bold text-center">Join as Mentor</h3>
                            <div className="border-t-4 border-orange-500 mt-1 mx-auto w-10 rounded-full"></div>
                        </div>
                        <p className='md:w-[90%] mx-auto my-3'>Join AS-Tech as a mentor, share your expertise, guide rising talent, and make a lasting impact on the next generation</p>
                        <Link
                            to='/mentor-login'
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-4"
                        >
                            Join Now
                        </Link>
                    </Link>
                    {/* <Link to='/freelancer-form' className="border-2 border-logo rounded-lg shadow-xl p-3 md:p-6 text-cente transition-all duration-500 ease-in-out transform">
                        <h3 className="md:text-2xl text-xl font-bold text-center">Join As Freelancer</h3>
                        <p className='md:w-[90%] mx-auto my-3'>Join AS-Tech as a freelancer, showcase your skills globally, set your rates, and work on exciting, impactful projects today</p>
                        <Link
                            to='/freelancer-form'
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-4"
                        >
                            Join Now
                        </Link>
                    </Link> */}
                </div>
            </div>
            <Footer />
        </>
    )
}

export default JoinCommunity
